import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
`

export const Span = styled.span`
  font-weight: 400;
  font-size: 16px;
  width: 288px;
  line-height: 20px;
  margin: 0px 15px;
  color: ${({ theme }) => theme.colors.grey84};
  text-align: center;
`

export const Img = styled.img`
  margin: 72px 0;
`

export const ModalFooterComponent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const ModalButton = styled(Button)`
  width: 288px;
`
